export const isLocalEnvironment = ['localhost', '127.0.0.1', '::1', '[::1]'].includes(window.location.hostname);
const apiBaseUrl = isLocalEnvironment ? 'http://localhost:8080/api/v1' : 'https://api.bubbleplan.net/v1';

export const api = {
  users: { url: `${apiBaseUrl}/users` },
  contactmail: { url: `${apiBaseUrl}/contactmail` },
  auth: { url: `${apiBaseUrl}/auth` },
  forgotpassword: { url: `${apiBaseUrl}/password/remind` },
  reset: { url: `${apiBaseUrl}/password/reset` },
  getuser: { url: `${apiBaseUrl}/users/me` },
  companies: { url: `${apiBaseUrl}/companies` },
  companyinvites: { url: `${apiBaseUrl}/companyinvites` },
  files: { url: `${apiBaseUrl}/files` },
  buy: { url: `${apiBaseUrl}/buy` },
};

export const app = {
  url: isLocalEnvironment ? 'http://localhost:8081/#/' : 'https://app.bubbleplan.net/#/',
};

export const keys = {
  stripe: isLocalEnvironment ? 'pk_test_ZSvv85IquUi9RIVLObsc4lmw' : 'pk_live_WzXkaTeYtwqEh1PUC357fQus',
};

export const recaptchaSiteKey = '6LdCAwgsAAAAANi8wcbPubBj06c4zqKshvAI71Pn';
export const recaptchaScriptUrl = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
